module.exports = __webpack_public_path__ + "img/03.4441cebd.jpg";